import React, { useEffect, useContext } from "react";
import { MLBPlayersDashboardTab } from "../MLBPlayersDashboardStyles";
import MLBPlayerRequestsHeader from "./MLBPlayerRequestsHeader";
import RequestBody from "./MLBRequestBody";
import WBCYearsContext from "../../../contexts/WBCYearsContext";
import MLBPlayerRequestContext from "../../../contexts/MLBPlayerRequestContext";
import MLBPlayerRequestApi from "../../../httpClients/MLBPlayerRequestApi";
import MLBPlayerSummaryApi from "../../../httpClients/MLBPlayerSummaryApi";
import AuthContext from "../../../contexts/AuthContext";

const MLBPlayerRequest = () => {
  const { selectedWbcYear } = useContext(WBCYearsContext);
  const authContext = useContext(AuthContext);
  const { setPlayerRequests, setPlayerStatuses } = useContext(MLBPlayerRequestContext);
  const ALL_STATUS = { label: "All", value: null };
  const { isBOC } = authContext.state;
  // get countries from local storage
  const userData = JSON.parse(localStorage.getItem("userData"));

  useEffect(() => {
    if (selectedWbcYear?.year) {
      const fetchPlayerRequests = async () => {
        if (isBOC) {
          const res = await MLBPlayerRequestApi.getMLBPlayerRequestsByYear(selectedWbcYear.year);
          setPlayerRequests(res?.length ? res : []);
        } else if (userData?.assignments?.length) {
          const res = await MLBPlayerRequestApi.getMLBPlayerRequestsByYearAndFedTeamIds(
            selectedWbcYear.year,
            userData.assignments.map(assignment => assignment.fedTeamId)
          );
          setPlayerRequests(res?.length ? res : []);
        }
      };
      fetchPlayerRequests();
    }

    const fetchPlayerStatuses = async () => {
      const statuses = await MLBPlayerSummaryApi.getStatuses();
      statuses?.length ? setPlayerStatuses([ALL_STATUS, ...statuses]) : setPlayerStatuses([ALL_STATUS]);
    };

    fetchPlayerStatuses();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedWbcYear]);

  return (
    <MLBPlayersDashboardTab>
      <MLBPlayerRequestsHeader />
      <RequestBody />
    </MLBPlayersDashboardTab>
  );
};

export default MLBPlayerRequest;
